<div *ngIf="showFavorite">
  <div class="side-nav" id="favouritesContainer">
    <span class="favourite-title">{{ dataService.res('Ubt-Favorites-Favorites') }}</span>
    <a id="closeFavoritebtn" class="close-btn" (click)="closeFavorites()">&times;</a>
    <div class="favorites-container">
      <favorites
        [ObjectTypeNames]="ObjectTypeNames"
        (onItemClicked)="itemClicked($event)"
        [appObjectTypesKeys]="appObjectTypesKeys"
      >
      </favorites>
    </div>
  </div>
</div>
